import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationService } from '../services/authorization.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

    constructor(private route: ActivatedRoute, public spinner:NgxSpinnerService, public authorizationService: AuthorizationService, public router: Router) { }
    ngOnInit(): void {        
    }

    showresult() {
        let codevalue;
        if (!window.location.hash || window.location.hash.length === 0) {
            const queryString = window.location.search.substring(1); // substring strips '?'
            const path = [window.location.pathname, queryString].join('#');
            window.location.assign(new URL(path, window.location.href).toString());
        }
         else if (new URLSearchParams(window.location.hash.substring(12)).has('code')) {//for prod
        //else if (new URLSearchParams(window.location.hash.substring(1)).has('code')) {// for dev
            this.route.queryParams.subscribe(
                params => {
                    codevalue = (params['code']);
                });
            this.authorizationService.completeAuthorizationRequest(codevalue).then((tokenResponse) => {
                console.log('recieved token response: ' + tokenResponse);
                this.router.navigate(['/home/AppCatalog']);
            });
        } else {
            console.log('did not recognize callback in URL fragment or query');
            this.router.navigate(['/home/AppCatalog']);
        }
    }
}